import { render, staticRenderFns } from "./DetailedPanel.vue?vue&type=template&id=5e8b1b5c&"
import script from "./DetailedPanel.vue?vue&type=script&lang=js&"
export * from "./DetailedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports